import React, { useEffect, useState } from 'react';
import '../assets/css/contact.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import emailjs from '@emailjs/browser';
import { countryCodes, getDialCode } from '../data/countryCodes';

const EMAILJS_CONFIG = {
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_hkhj1k8',
    templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_freg9in',
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'XqjsT_gI4D6cMu3oD',
    recipient: process.env.REACT_APP_CONTACT_EMAIL || 'info@cloudmindx.com'
};

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        countryIso: 'UAE',
        phone: '',
        message: ''
    });

    const [status, setStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        if (status) {
            setStatus('');
        }

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        setStatus('sending');

        const cleanData = Object.fromEntries(
            Object.entries(formData).map(([key, value]) => [key, value.trim()])
        );

        const templateParams = {
            to_email: EMAILJS_CONFIG.recipient,
            to_name: 'Cloud Mind X Team',
            from_name: `${cleanData.firstName} ${cleanData.lastName}`,
            first_name: cleanData.firstName,
            last_name: cleanData.lastName,
            from_email: cleanData.email,
            reply_to: cleanData.email,
            phone: `${getDialCode(cleanData.countryIso)} ${cleanData.phone}`,
            message: cleanData.message,
            subject: `New contact enquiry from ${cleanData.firstName} ${cleanData.lastName}`,
            submitted_at: new Date().toLocaleString('en-IN', {
                dateStyle: 'medium',
                timeStyle: 'short',
                timeZone: 'Asia/Kolkata'
            })
        };

        try {
            await emailjs.send(
                EMAILJS_CONFIG.serviceId,
                EMAILJS_CONFIG.templateId,
                templateParams,
                { publicKey: EMAILJS_CONFIG.publicKey }
            );

            setStatus('success');
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                countryIso: 'UAE',
                phone: '',
                message: ''
            });
        } catch (error) {
            console.error('Contact form email failed:', error);
            setStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="contact-page">
                {/* Breadcrumb Hero Section */}
                <section className="breadcrumb-hero">
                    <div className="breadcrumb-overlay"></div>
                    <div className="breadcrumb-content">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    {/* <div className="breadcrumb-tagline">
                                        <span className="breadcrumb-line"></span>
                                        <span className="breadcrumb-text">INTELLIGENTLY DRIVE BUSINESS GROWTH</span>
                                    </div> */}
                                    <h1 className="breadcrumb-title">
                                        Contact Us <span className="breadcrumb-highlight">CLOUD MIND X</span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="breadcrumb-pattern"></div>
                </section>
            </div>

            {/* Contact Section */}
            <section className="contact-section">
                <div className="contact-bg-overlay"></div>
                <div className="container">
                    {/* Top Heading Section */}
                    <div className="contact-header text-center">
                        <h2 className="contact-main-title">Send Us a Message</h2>
                        <p className="contact-main-subtitle">
                            Please fill in the form below to get in touch with us.
                        </p>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Contact Info */}
                        <div className="col-lg-5">
                            <div className="contact-info-wrapper">
                                <div className="contact-details">
                                    {/* Address */}
                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="contact-text">
                                            <h4 style={{ textAlign: 'left' }}>Address</h4>
                                            <p style={{ textAlign: 'left' }}>One Business Center, Media One Hotel Tower - 38th Floor - Al Sufouh - Dubai Media City - Dubai - United Arab Emirates</p>
                                        </div>
                                    </div>

                                    {/* Phone */}
                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="contact-text">
                                            <h4>Phone</h4>
                                            <p>+971-501227432</p>
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="contact-text">
                                            <h4>Email</h4>
                                            <p>info@cloudmindx.com</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Contact Form */}
                        <div className="col-lg-7">
                            <div className="contact-form-wrapper">
                                {/* <h3 className="form-title">Send Message</h3> */}
                                <form onSubmit={handleSubmit} className="contact-form">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    name="firstName"
                                                    placeholder="First name"
                                                    value={formData.firstName}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    autoComplete="given-name"
                                                    maxLength="60"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    name="lastName"
                                                    placeholder="Last name"
                                                    value={formData.lastName}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    autoComplete="family-name"
                                                    maxLength="60"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email address"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    autoComplete="email"
                                                    maxLength="254"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="country-phone-control contact-phone-control">
                                                    <select
                                                        name="countryIso"
                                                        value={formData.countryIso}
                                                        onChange={handleChange}
                                                        aria-label="Country"
                                                    >
                                                        {countryCodes.map(({ iso }) => (
                                                            <option key={iso} value={iso}>
                                                                {iso}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <span className="country-dial-code">
                                                        {getDialCode(formData.countryIso)}
                                                    </span>
                                                    <input
                                                        type="tel"
                                                        name="phone"
                                                        placeholder="Phone number"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                        autoComplete="tel-national"
                                                        inputMode="tel"
                                                        pattern="[0-9 ()-]{6,20}"
                                                        maxLength="20"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <textarea
                                            name="message"
                                            placeholder="Message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            className="form-control"
                                            rows="5"
                                            minLength="10"
                                            maxLength="3000"
                                            required
                                        ></textarea>
                                    </div>

                                    {/* <div className="form-group form-terms">
                                        <label className="terms-label">
                                            <input type="checkbox" required />
                                            <span>I've read and agree with <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a></span>
                                        </label>
                                    </div> */}

                                    <div aria-live="polite" role="status">
                                    {status === 'success' && (
                                        <div className="alert alert-success" style={{ color: 'green', marginBottom: '10px' }}>
                                            Thank you for contacting us! We will get back to you soon.
                                        </div>
                                    )}
                                    {status === 'error' && (
                                        <div className="alert alert-error" style={{ color: 'red', marginBottom: '10px' }}>
                                            Failed to send message. Please try again.
                                        </div>
                                    )}
                                    </div>

                                    <button type="submit" className="breadcrumb-btn submit-btn-custom" disabled={isSubmitting}>
                                        <span>{isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}</span>
                                        <span className="breadcrumb-arrow">

                                        </span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How It Works Section */}
            <section className="how-it-works-section">
                <div className="container">
                    <div className="section-header text-center">
                        <h6 className="section-tagline">OUR PROCESS</h6>
                        <h2 className="section-title" style={{ textAlign: 'center' }}>From idea to execution</h2>
                        <p className="process-section-subtitle">
                            A simple, transparent process designed to move your project forward with clarity and confidence.
                        </p>
                    </div>

                    <div className="row process-cards-wrapper">
                        {/* Step 1: Submit a Request */}
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="process-card">
                                <span className="process-step">01</span>
                                <div className="process-icon-wrapper">
                                    <div className="process-icon">
                                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.33334 8.33337H37.5L45.8333 25L25 41.6667L4.16667 25L8.33334 8.33337Z" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M25 25L37.5 8.33337" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M14.5833 16.6666L4.16667 25L25 41.6667V25" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M35.4167 16.6666L45.8333 25L25 41.6667" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="process-content">
                                    <h3 className="process-title">Submit a Request</h3>
                                    <p className="process-timeline">Reply in 24 hours</p>
                                    <p className="process-description">
                                        Tell us about your goals, requirements, audience and preferred timeline. The more context you share, the more accurately we can assess your needs.
                                    </p>
                                    <div className="process-outcome"><span>Outcome</span> Initial consultation</div>
                                </div>
                            </div>
                        </div>

                        {/* Step 2: Project Quote/Proposal */}
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="process-card">
                                <span className="process-step">02</span>
                                <div className="process-icon-wrapper">
                                    <div className="process-icon">
                                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M39.5833 8.33337H10.4167C8.57573 8.33337 7.08334 9.82576 7.08334 11.6667V38.3334C7.08334 40.1743 8.57573 41.6667 10.4167 41.6667H39.5833C41.4243 41.6667 42.9167 40.1743 42.9167 38.3334V11.6667C42.9167 9.82576 41.4243 8.33337 39.5833 8.33337Z" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M33.3333 4.16663V12.5" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M16.6667 4.16663V12.5" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M7.08334 20.8334H42.9167" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M17.5 27.0834H22.9167" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M17.5 33.3334H27.0833" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="process-content">
                                    <h3 className="process-title">Project Quote/Proposal</h3>
                                    <p className="process-timeline">Estimated in 2-3 days</p>
                                    <p className="process-description">
                                        Our specialists review your requirements and recommend the right technical approach, project scope, delivery plan and transparent cost estimate.
                                    </p>
                                    <div className="process-outcome"><span>Outcome</span> Tailored proposal</div>
                                </div>
                            </div>
                        </div>

                        {/* Step 3: Start a Project */}
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="process-card">
                                <span className="process-step">03</span>
                                <div className="process-icon-wrapper">
                                    <div className="process-icon">
                                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="25" cy="25" r="20.8333" stroke="#4187f7" strokeWidth="2.5" />
                                            <path d="M25 10.4166V25L33.3333 29.1666" stroke="#4187f7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="25" cy="25" r="2.08333" fill="#4187f7" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="process-content">
                                    <h3 className="process-title">Start a Project</h3>
                                    <p className="process-timeline">2 days after approval</p>
                                    <p className="process-description">
                                        Once approved, we finalize milestones, introduce your dedicated team and begin delivery with clear communication at every stage.
                                    </p>
                                    <div className="process-outcome"><span>Outcome</span> Project kickoff</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Locations Section */}
            {/* <section className="locations-section">
                <div className="container">
                    <div className="section-header text-center">
                        <h2 className="section-title">Our Global Presence</h2>
                        <p className="section-subtitle">We're here to serve you worldwide</p>
                    </div>
                    <div className="row">
                        {locations.map((location, index) => (
                            <div className="col-lg-3 col-md-6 mb-4" key={index}>
                                <div className="location-card">
                                    <div className="location-image">
                                        <img src={location.image} alt={location.city} />
                                    </div>
                                    <div className="location-content">
                                        <h4 className="location-country">{location.country}</h4>
                                        <h5 className="location-city">{location.city}</h5>
                                        <p className="location-address">{location.address}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}
        </>

    );
};

export default Contact;
